<template>
    <div ref="pageBox">
        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="$t('Account.receiptRecord')" name="first">
                <SearchBox ref="SearchBox1">
                    <el-form slot="form" :inline="true" ref="searchData1" :model="searchParams1" label-width="80px"
                             class="unitWidth" size="small">
                        <el-form-item :label="$t('Shift.factory')">
                            <el-select v-model="infcCode" :placeholder="$t('base.PleaseSelect')" :clearable="isclear" :disabled="ischeck"
                                       filterable @change="fcChange1">
                                <el-option v-for="factory in factoryList" :key="factory.factoryId"
                                           :label="factory.fcName" :value="factory.fcCode"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('Account.storeName')">
                            <el-select v-model="instrCode" :placeholder="$t('base.PleaseSelect')" clearable filterable
                                       @change="searchTable1">
                                <el-option v-for="house in houseList" :key="house.spsId" :label="house.strName"
                                           :value="house.strCode"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item label="使用类型">
                            <el-select v-model="purchaseType" placeholder="请选择分类(必填)" clearable @change="searchTable1">
                                <el-option label="采购" value="CG"></el-option>
                                <el-option label="二次利用" value="ST"></el-option>
                                <el-option label="其它" value="SE"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item :label="$t('Account.receiptCode')">
                            <el-input v-model.trim="purchaseCode" :placeholder="$t('base.PleaseEnter')"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Account.spareCode')">
                            <el-input v-model.trim="spCode" :placeholder="$t('base.PleaseEnter')"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Account.spareName')">
                            <el-input v-model.trim="spName" :placeholder="$t('base.PleaseEnter')"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Account.CostCenter')">
                            <el-input v-model.trim="costCenter" :placeholder="$t('base.PleaseEnter')"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Account.receiptTime')">
                            <el-date-picker
                                style="width: 50vh"
                                v-model="dateRange"
                                type="daterange"
                                range-separator="-"
                                :start-placeholder="$t('Account.startTime')"
                                :end-placeholder="$t('Account.endTime')"
                                @change="searchTable1"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-button style="margin-top: 0.3vw" size="small" type="primary" @click="searchTable1">{{$t('base.search')}}
                        </el-button>
                    </el-form>
                </SearchBox>
                <LabelContent :title="$t('Account.receiptRecord')" ref="LabelContent">
                    <div slot="btns">
                        <el-button size="small" type="success" @click="exportSparePartPurchaseItem()">{{$t('base.export')}}</el-button>
                    </div>
                </LabelContent>
                <div class="tableBox">
                    <el-table stripe ref="multipleTable1" :data="tableData1" class="center"
                              @selection-change="handleSelectionChange" @sort-change="sortChange" border>
                        <el-table-column prop="purchaseCode" :label="$t('Account.receiptCode')" width="160"/>
                        <el-table-column prop="strName" :label="$t('Account.storeName')" width="120"/>
                        <el-table-column prop="sppName" :label="$t('Account.locatorName')" width="120"/>
                        <el-table-column prop="batchNo" :label="$t('Account.batchNo')" width="120"/>
                        <el-table-column prop="spCode" :label="$t('Account.spareCode')" width="120"/>
                        <el-table-column prop="spName" :label="$t('Account.spareName')" width="120"/>
                        <el-table-column prop="costCenter" :label="$t('Account.CostCenter')" width="120"/>
                        <el-table-column prop="spcName" :label="$t('Account.spareSortName')" width="120"/>
                        <el-table-column prop="spBrand" :label="$t('Account.spareBrand')" width="120"/>
                        <el-table-column prop="spLevel" :label="$t('Account.spareSort')" width="120"/>
                        <el-table-column prop="spModel" :label="$t('Account.spareModel')" width="120"/>
                        <el-table-column prop="amount" sortable :label="$t('Account.number')" width="90"/>
                        <!-- <el-table-column prop="unit" label="备件单位" width="120" /> -->
                        <el-table-column prop="totalPrice" sortable :label="$t('Account.totalPrice')" width="100"/>
                        <el-table-column prop="createTime" :label="$t('Role.createTime')" width="160"/>
                    </el-table>
                </div>
                <el-pagination
                    @size-change="paginationChange1"
                    @current-change="paginationCurrentChange1"
                    :current-page="searchParams1.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="searchParams1.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="searchParams1.pageCount"
                />
            </el-tab-pane>
            <el-tab-pane :label="$t('Account.deliveryRecord')" name="second">
                <SearchBox ref="SearchBox2">
                    <el-form slot="form" :inline="true" ref="searchData2" :model="searchParams2" label-width="80px"
                             class="unitWidth" size="small">
                        <el-form-item :label="$t('Shift.factory')">
                            <el-select v-model="outfcCode" :placeholder="$t('base.PleaseSelect')" :clearable="isclear" :disabled="ischeck"
                                       filterable @change="fcChange2">
                                <el-option v-for="factory in factoryList" :key="factory.factoryId"
                                           :label="factory.fcName" :value="factory.fcCode"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('Account.storeName')">
                            <el-select v-model="outstrCode" :placeholder="$t('base.PleaseSelect')" clearable filterable
                                       @change="searchTable2">
                                <el-option v-for="house in houseList" :key="house.spsId" :label="house.strName"
                                           :value="house.strCode"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item label="使用类型">
                            <el-select v-model="useType" placeholder="请选择使用类型(必填)" clearable @change="searchTable2">
                                <el-option label="安灯" value="andon"></el-option>
                                <el-option label="其它" value="other"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item :label="$t('Account.deliveryCode')">
                            <el-input v-model.trim="deliveryCode" :placeholder="$t('base.PleaseEnter')"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Account.spareCode')">
                            <el-input v-model.trim="spCode" :placeholder="$t('base.PleaseEnter')"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Account.spareName')">
                            <el-input v-model.trim="spName" :placeholder="$t('base.PleaseEnter')"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Account.CostCenter')">
                            <el-input v-model.trim="costCenter" :placeholder="$t('base.PleaseEnter')"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Account.deliveryTime')">
                            <el-date-picker
                                style="width: 50vh"
                                v-model="dateRange"
                                type="daterange"
                                range-separator="-"
                                :start-placeholder="$t('Account.startTime')"
                                :end-placeholder="$t('Account.endTime')"
                                @change="searchTable2"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-button style="margin-top: 0.3vw" size="small" type="primary" @click="searchTable2">{{$t('base.search')}}
                        </el-button>
                    </el-form>
                </SearchBox>
                <LabelContent :title="$t('Account.deliveryRecord')" ref="LabelContent">
                    <div slot="btns">
                        <el-button size="small" type="success" @click="exportSparePartDeliveryItem()">{{$t('base.export')}}</el-button>
                    </div>
                </LabelContent>
                <div class="tableBox">
                    <el-table stripe ref="multipleTable2" :data="tableData2" class="center"
                              @selection-change="handleSelectionChange" @sort-change="sortChange" border>
                        <el-table-column prop="deliveryCode" :label="$t('Account.deliveryCode')" width="160"/>
                        <el-table-column prop="strName" :label="$t('Account.storeName')" width="120"/>
                        <el-table-column prop="sppName" :label="$t('Account.locatorName')" width="120"/>
                        <el-table-column prop="batchNo" :label="$t('Account.batchNo')" width="120"/>
                        <el-table-column prop="spCode" :label="$t('Account.spareCode')" width="120"/>
                        <el-table-column prop="spName" :label="$t('Account.spareName')" width="120"/>
                        <el-table-column prop="costCenter" :label="$t('Account.CostCenter')" width="120"/>
                        <el-table-column prop="spcName" :label="$t('Account.spareSortName')" width="120"/>
                        <el-table-column prop="spBrand" :label="$t('Account.spareBrand')" width="120"/>
                        <el-table-column prop="spLevel" :label="$t('Account.spareSort')" width="120"/>
                        <el-table-column prop="spModel" :label="$t('Account.spareModel')" width="120"/>
                        <el-table-column prop="amount" sortable :label="$t('Account.number')" width="90"/>
                        <!-- <el-table-column prop="unit" label="备件单位" width="120" /> -->
                        <el-table-column prop="totalPrice" sortable :label="$t('Account.totalPrice')" width="100"/>
                        <el-table-column prop="createTime" :label="$t('Role.createTime')" width="160"/>
                    </el-table>
                </div>
                <el-pagination
                    @size-change="paginationChange2"
                    @current-change="paginationCurrentChange2"
                    :current-page="searchParams2.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="searchParams2.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="searchParams2.pageCount"
                />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import { getAllPartPurchaseOrder } from '../../../libs/api'

    export default {
        name: 'sparePartsWarehousing',
        data() {
            return {
                searchParams1: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                searchParams2: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                tableData1: [],
                tableData2: [],
                partDeliveryItemList: [],
                factoryList: [],
                houseList: [],
                partPurchaseItemList: [],
                infcCode: '',
                outfcCode: '',
                instrCode: '',
                outstrCode: '',
                useType: '',
                deliveryCode: '',
                purchaseType: '',
                purchaseCode: '',
                dateRange: '',
                spCode: '',
                spName: '',
                costCenter: '',
                userInfo: {},
                role: {},
                ischeck: true,
                isclear: false,
                activeName: 'first',
                access: []
            }
        },
        mounted() {
            this.init()
        },
        activated() {
            this.init()
        },
        methods: {
            init() {
                // this.userInfo = sessionStorage.getItem("userInfo")
                this.access = JSON.parse(sessionStorage.getItem('auths'))
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.isclear = true
                        this.role = role[i]
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                this.getAllFactory()
            },
            //分页
            paginationChange1(val) {
                this.searchParams1.pageSize = val
                this.searchTable1()
            },
            paginationChange2(val) {
                this.searchParams2.pageSize = val
                this.searchTable2()
            },
            paginationCurrentChange1(val) {
                this.searchParams1.page = val
                this.searchTable1()
            },
            paginationCurrentChange2(val) {
                this.searchParams2.page = val
                this.searchTable2()
            },
            //多选框选择 返回当前已选行数据(Array)
            handleSelectionChange(val) {
                console.log(val)
            },
            //从后台获取数据,重新排序
            sortChange(val) {
                // 详细文档参考： https://element.eleme.cn/2.13/#/zh-CN/component/table
                console.log(val)
            },
            fcChange1() {
                this.instrCode = ''
                this.partStoreHouseList1()
                this.searchTable1()
            },
            fcChange2() {
                this.outstrCode = ''
                this.partStoreHouseList2()
                this.searchTable2()
            },
            getAllFactory() {
                let options = {
                    method: 'get',
                    url: this.$api.getAllFactory
                }
                this.$http.request(options).then((response) => {
                    if (response.status == 100) {
                        this.factoryList = []
                        var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                        var aa = response.data
                        if (this.ischeck) {
                            for (var i = 0; i < aa.length; i++) {
                                for (let j = 0; j < userInfo.roles.length; j++) {
                                    if (aa[i].factoryId == userInfo.roles[j].factoryId) {
                                        this.factoryList.push(aa[i])
                                        this.infcCode = this.userInfo.fcCode
                                        this.outfcCode = this.userInfo.fcCode
                                        this.partStoreHouseList1()
                                    }
                                }
                            }
                        } else {
                            this.factoryList = response.data
                        }
                    }
                    this.searchTable1()
                })
            },
            partStoreHouseList1() {
                if (this.infcCode == undefined || this.infcCode == '') {
                    return this.houseList = []
                }
                let options = {
                    method: 'get',
                    url: this.$api.partStoreHouseList,
                    params: { fcCode: this.infcCode }
                }
                this.$http.request(options).then((response) => {
                    if (response.status == 100) {
                        this.houseList = response.data
                    }
                })
            },
            partStoreHouseList2() {
                if (this.outfcCode == undefined || this.outfcCode == '') {
                    return this.houseList = []
                }
                let options = {
                    method: 'get',
                    url: this.$api.partStoreHouseList,
                    params: { fcCode: this.outfcCode }
                }
                this.$http.request(options).then((response) => {
                    if (response.status == 100) {
                        this.houseList = response.data
                    }
                })
            },
            handleClick(tab, event) {
                // console.log(tab, event)
                if (tab.name == 'first') {
                    // 触发‘入库记录’事件
                    this.purchaseCode = ''
                    this.dateRange = ''
                    this.spCode = ''
                    this.spName = ''
                    this.costCenter = ''
                    this.partStoreHouseList1()
                    this.searchTable1()
                } else {
                    // 触发‘出库记录’事件
                    this.deliveryCode = ''
                    this.dateRange = ''
                    this.spCode = ''
                    this.spName = ''
                    this.costCenter = ''
                    this.partStoreHouseList2()
                    this.searchTable2()
                }
            },
            //入库导出
            async exportSparePartPurchaseItem() {
                let queryParams = {}
                queryParams['language'] = this.$t('lang')
                if (this.infcCode != undefined && this.infcCode != '') {
                    queryParams['fcCode'] = this.infcCode
                }
                if (this.instrCode != undefined && this.instrCode != '') {
                    queryParams['strCode'] = this.instrCode
                }
                if (this.purchaseType != undefined && this.purchaseType != '') {
                    queryParams['purchaseType'] = this.purchaseType
                }
                if (this.purchaseCode != undefined && this.purchaseCode != '') {
                    queryParams['purchaseCode'] = this.purchaseCode
                }
                if (this.spCode != undefined && this.spCode != '') {
                    queryParams['spCode'] = this.spCode
                }
                if (this.spName != undefined && this.spName != '') {
                    queryParams['spName'] = this.spName
                }
                if (this.costCenter != undefined && this.costCenter != '') {
                    queryParams['costCenter'] = this.costCenter
                }
                if (this.dateRange != null && this.dateRange != '') {
                    if (this.dateRange.length > 0 && this.dateRange[0] != '') {
                        queryParams['startTime'] = this.$moment(this.dateRange[0]).format('YYYY-MM-DD') + ' 00:00:00'
                        queryParams['endTime'] = this.$moment(this.dateRange[1]).format('YYYY-MM-DD') + ' 23:59:59'
                    }
                }
                let options = {
                    method: 'POST',
                    params: queryParams,
                    url: this.$api.exportSparePartPurchaseItem,
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                    }
                }
                let result = await this.$http.request(options)
                var elink = document.createElement('a')
                elink.download = this.$t('Account.receiptInfo')  //设置名称
                elink.style.display = 'none'
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)  //追加节点
                elink.click()
                document.body.removeChild(elink)  //删除节点
            },
            //入库
            searchTable1() {
                let queryParams = {
                    pageSize: this.searchParams1.pageSize,
                    pageNum: this.searchParams1.page
                }
                if (this.infcCode != undefined && this.infcCode != '') {
                    queryParams['fcCode'] = this.infcCode
                }
                if (this.instrCode != undefined && this.instrCode != '') {
                    queryParams['strCode'] = this.instrCode
                }
                if (this.purchaseType != undefined && this.purchaseType != '') {
                    queryParams['purchaseType'] = this.purchaseType
                }
                if (this.purchaseCode != undefined && this.purchaseCode != '') {
                    queryParams['purchaseCode'] = this.purchaseCode
                }
                if (this.spCode != undefined && this.spCode != '') {
                    queryParams['spCode'] = this.spCode
                }
                if (this.spName != undefined && this.spName != '') {
                    queryParams['spName'] = this.spName
                }
                if (this.costCenter != undefined && this.costCenter != '') {
                    queryParams['costCenter'] = this.costCenter
                }
                if (this.dateRange != null && this.dateRange != '') {
                    if (this.dateRange.length > 0 && this.dateRange[0] != '') {
                        queryParams['startTime'] = this.$moment(this.dateRange[0]).format('YYYY-MM-DD') + ' 00:00:00'
                        queryParams['endTime'] = this.$moment(this.dateRange[1]).format('YYYY-MM-DD') + ' 23:59:59'
                    }
                }
                let options = {
                    method: 'get',
                    url: this.$api.getPurchaseItemPageList,
                    params: queryParams
                }
                this.$http.request(options).then((response) => {
                    if (response.status == 100) {
                        console.log(response.data)
                        this.tableData1 = response.data.list
                        this.searchParams1.pageCount = response.data.total
                    }
                })
            },
            //出库导出
            async exportSparePartDeliveryItem() {
                let queryParams = {}
                queryParams['language'] = this.$t('lang')
                if (this.outfcCode != undefined && this.outfcCode != '') {
                    queryParams['fcCode'] = this.outfcCode
                }
                if (this.outstrCode != undefined && this.outstrCode != '') {
                    queryParams['strCode'] = this.outstrCode
                }
                if (this.useType != undefined && this.useType != '') {
                    queryParams['useType'] = this.useType
                }
                if (this.deliveryCode != undefined && this.deliveryCode != '') {
                    queryParams['deliveryCode'] = this.deliveryCode
                }
                if (this.spCode != undefined && this.spCode != '') {
                    queryParams['spCode'] = this.spCode
                }
                if (this.spName != undefined && this.spName != '') {
                    queryParams['spName'] = this.spName
                }
                if (this.costCenter != undefined && this.costCenter != '') {
                    queryParams['costCenter'] = this.costCenter
                }
                if (this.dateRange != null && this.dateRange != '') {
                    if (this.dateRange.length > 0 && this.dateRange[0] != '') {
                        queryParams['startTime'] = this.$moment(this.dateRange[0]).format('YYYY-MM-DD') + ' 00:00:00'
                        queryParams['endTime'] = this.$moment(this.dateRange[1]).format('YYYY-MM-DD') + ' 23:59:59'
                    }
                }
                let options = {
                    method: 'POST',
                    params: queryParams,
                    url: this.$api.exportSparePartDeliveryItem,
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                    }
                }
                let result = await this.$http.request(options)
                var elink = document.createElement('a')
                elink.download = this.$t('Account.deliveryInfo')  //设置名称
                elink.style.display = 'none'
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)  //追加节点
                elink.click()
                document.body.removeChild(elink)  //删除节点
            },
            //出库
            searchTable2() {
                let queryParams = {
                    pageSize: this.searchParams2.pageSize,
                    pageNum: this.searchParams2.page
                }
                if (this.outfcCode != undefined && this.outfcCode != '') {
                    queryParams['fcCode'] = this.outfcCode
                }
                if (this.outstrCode != undefined && this.outstrCode != '') {
                    queryParams['strCode'] = this.outstrCode
                }
                if (this.useType != undefined && this.useType != '') {
                    queryParams['useType'] = this.useType
                }
                if (this.deliveryCode != undefined && this.deliveryCode != '') {
                    queryParams['deliveryCode'] = this.deliveryCode
                }
                if (this.spCode != undefined && this.spCode != '') {
                    queryParams['spCode'] = this.spCode
                }
                if (this.spName != undefined && this.spName != '') {
                    queryParams['spName'] = this.spName
                }
                if (this.costCenter != undefined && this.costCenter != '') {
                    queryParams['costCenter'] = this.costCenter
                }
                if (this.dateRange != null && this.dateRange != '') {
                    if (this.dateRange.length > 0 && this.dateRange[0] != '') {
                        queryParams['startTime'] = this.$moment(this.dateRange[0]).format('YYYY-MM-DD') + ' 00:00:00'
                        queryParams['endTime'] = this.$moment(this.dateRange[1]).format('YYYY-MM-DD') + ' 23:59:59'
                    }
                }
                let options = {
                    method: 'get',
                    url: this.$api.getDeliveryItemPageList,
                    params: queryParams
                }
                this.$http.request(options).then((response) => {
                    if (response.status == 100) {
                        console.log(response.data)
                        this.tableData2 = response.data.list
                        this.searchParams2.pageCount = response.data.total
                    }
                })
            }
        }
    }
</script>

<style scoped>
</style>
